import * as React from "react";
import { Tooltip } from "antd";
import classNames from "classnames";

interface IProps {
	onClick?: (value?: {}) => void;
	icon?: {};
	children?: {};
	link?: string;
	title?: string;
	className?: string;
	style?: {};
	type?: "button" | "submit" | "reset";
	disabled?: boolean;
}

const IconButton: React.FC<IProps> = (props) => {
	const Button = (
		<span>
			<button
				style={props.style}
				type={props.type || "button"}
				className={classNames(
					props.className,
					"btn btn-icon btn-link btn-pd-fix"
				)}
				disabled={props.disabled}
				onClick={props.onClick}
			>
				{props.icon}
				{props.children}
			</button>
		</span>
	);

	if (props.title) {
		return <Tooltip title={props.title}>{Button}</Tooltip>;
	}

	return Button;
};

export default IconButton;
